/**
 * Created by Administrator on 2016/9/28.
 */
import './dialog.js'
import clientType from "./clientType.js"
import Utils from '../../common/utils.js'
import consoleHelper from './common_script/helper/consoleHelper'
import "./errorMessageList.js"

//打包配置
var devConfig = {
    isDebug: false,
    isDev: true,
    // qcloud video appId
    // appId:"1252682191", //正式appID
    // appId: "1488484692", //测试appID
    // appId: "1255764641", //测试appID
    appId: "1304629723", // 测试appID (新腾讯云账号)
    apiHostname : 'jee.shixun365.com',
    // apiHostname : '192.168.1.113:8080',
    qqMapKey : 'KVRBZ-XCAC3-PNY3I-3G27S-XHYV6-7NBWU',
    prefix: {
        realmName: "//jee.shixun365.com/shixun/"  //测试
        // realmName: "//localhost:8080/shixun/"
        // realmName: "//192.168.1.113:8080/shixun/"
    }
};
var testConfig = {
    isDebug: true,
    // qcloud video appId
    //  appId:"1252682191", //正式appID
    // appId: "1255764641", //测试appID
    appId: "1304629723", // 测试appID (新腾讯云账号)
    // apiHostname : 'jee.shixun365.com',  //测试
    // apiHostname : 'api.shixun365.com',  //正式
    qqMapKey : 'KVRBZ-XCAC3-PNY3I-3G27S-XHYV6-7NBWU',
    prefix: {
      realmName: "//jee.shixun365.com/shixun/"  //测试
      // realmName: "//localhost:8080/shixun/"
    }
};
var qaConfig = {
    isDebug: false,
    prefix: {
        realmName: "//shixunapi.xsili.com/qa/shixun/"
    }
};
var publishConfig = {
    isDebug: false,
    // qcloud video appId
    appId:"1252682191", //正式appID
    apiHostname : 'api.shixun365.com',
    qqMapKey : 'KVRBZ-XCAC3-PNY3I-3G27S-XHYV6-7NBWU',
    prefix: {
        realmName: "//api.shixun365.com/shixun/"
    }
};

if (__DEV__) {
    window.Link = devConfig;
} else if (__BETA__) {
    window.Link = testConfig;
} else if (__PRODUCTION__) {
    window.Link = publishConfig;
}
// TODO 后续新增gulp qa
// TODO 备注:login.html 安卓苹果nativeCallJSWXLogin回调方法 请求登录接口url需换
//window.Link = qaConfig;
//window.Link = publishConfig;


window.Link.g = {
    isMe:       undefined,
    introCode:  undefined,
    deptCode:   undefined
};

/**
 * @param Function callback
 * - user  String | Object
 */
Link.verifyLoin = function (callback) {
    $.ajax({
        url: Link.prefix.realmName + "login/portal/verify_login",
        type: 'POST',
        success: function (data, textStatus, request) {

            consoleHelper.logDebug('ajax success.');

            // 错误 complete 已做处理
            // if (data.errorCode == 1) {
            //     dialog.msg(data.msg);
            //     return;
            // }
            // 未登录 complete 已做处理
            // if (data.errorCode == 2) {
            //     // var baseUrl = location.href.split('html')[0] + 'html/';
            //     // location.href = baseUrl + '
            //     login/login.html';
            //     if (data.data != null) {
            //         if (Link.isDev) {
            //             // 模拟登陆, 可能出现还没有登录成功, 就执行其他逻辑的情况
            //             // alert('模拟登录');
            //             // simulateLogin();
            //         } else {
            //             //alert('微信登录');
            //             window.location.href = data.data;
            //         }
            //     } else {
            //         if (window.sessionStorage) {
            //             consoleHelper.logDebug('sessionStorage==ok');
            //         } else {
            //             consoleHelper.logDebug('sessionStorage==fail');
            //         }
            //         sessionStorage.setItem('gotoBeforeUrl', window.location.href);
            //         let type = clientType.type();
            //         if (type === 'phone') {
            //             window.location.href = location.href.split('shixun-mobile')[0] + 'shixun-mobile/html/login/login.html';
            //         } else {
            //             window.location.href = location.href.split('shixun-mobile')[0] + 'shixun-portal/html/app_login.html';
            //         }
            //     }
            //     return;
            // }

            // code = 6 is visitor
            if (data.errorCode && data.errorCode!=6) {
                // callback ? callback(result, null) : null;
                callback ? callback(null) : null;
                return;
            }

            let user = data.data;
            // allow not login
            // if (!user)
            // {
            //     return;
            // }

            if (user)
            {
                Link.g.introCode = user.introduceCode;
            }

            if (callback) {
                callback(user);
            }
        }
    })
};

/**
 * 请求获取优惠券详情,用于分享发送朋友的标题和描述
 */
Link.getCouponDetails = function (callback) {
    var param = Utils.param();
    var couponNo = param.couponNo;
    $.ajax({
        url: Link.prefix.realmName + "portal/coupon/get-coupon",
        data: {
            couponNo: couponNo
        },
        success: function (data) {
            // 错误
            if (data.errorCode != 0) {
                dialog.msg(data.msg)
                return;
            }
            let result = data.data;
            if (callback) {
                callback(result);
            }
        }
    })
};

/**
 * 获取jesessionId
 */
Link.getJessionId = function (callback) {
    $.ajax({
        url: Link.prefix.realmName + "base/jessionId/get",
        dataType: "json",
        success: function (data) {
            if (data.errorCode !== 0) {
                dialog.msg(data.msg);
                return;
            }
            let jessionId = "JSESSIONID=" + data.data;
            if (callback) {
                callback(jessionId);
            }
        },
        error: function (data) {
            consoleHelper.logDebug(data.msg)
        }
    });
};

//cb29ec136a114f34a1a2bb64408d3241
/**
 *
 * @param id myliveId or topicId or liveId
 * @param type mylive or topic or live
 * @param callback param isOwner
 */
Link.isOwner = function (id, type, callback) {
    if (type != 'mylive' && type != 'topic' && type != 'live') {
        throw new Error("参数type错误, 合法值:  mylive / topic / live");
    }
    $.ajax({
        url: Link.prefix.realmName + "portal/voicelive/mylive/isOwner",
        data: {
            id: id,
            type: type
        },
        success: function (data) {
            if (data.errorCode != 0) {
                dialog.msg(data.msg)
                return;
            }
            Link.g.isMe = data.data;

            if (callback) {
                callback(data.data);
            }
        }
    })
};

Link.getWxConfigVoice = function (callback) {
    _getWxConfig(Link.prefix.realmName + "base/wx/jssdkconfig/voice", callback);
};

Link.getWxConfigPay = function (callback) {
    _getWxConfig(Link.prefix.realmName + "base/wx/jssdkconfig/pay", callback);
};

Link.getWxConfigShare = function (callback) {
    _getWxConfig(Link.prefix.realmName + "base/wx/jssdkconfig/jssdk", callback);
};

/**
 * 微信sdk 配置信息
 * @param callback null param
 */
let _getWxConfig = function (url, callback) {
    $.ajax({
        url: url,
        data: {
            //url:encodeURIComponent(location.href.split('#')[0])
            url: location.href.split('#')[0]
        },
        success: function (data) {
            if (data.errorCode != 0) {
                dialog.msg(data.msg)
                return;
            }

            // 分享接口
            if (data.data.jsApiList == null || data.data.jsApiList.length == 0) {
                data.data.jsApiList = [
                    'onMenuShareTimeline',
                    'onMenuShareAppMessage',
                    'previewImage',
                ]
            } else {
                data.data.jsApiList.push('onMenuShareTimeline');
                data.data.jsApiList.push('onMenuShareAppMessage');
                data.data.jsApiList.push('previewImage');
            }

            wx.config({
                debug: false,// 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: data.data.appId, // 必填，公众号的唯一标识
                timestamp: data.data.timestamp, // 必填，生成签名的时间戳
                nonceStr: data.data.nonceStr, // 必填，生成签名的随机串
                signature: data.data.signature,// 必填，签名，见附录1
                jsApiList: data.data.jsApiList // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            });

            Link._onWxShare();

            if (callback) {
                callback();
            }
        }
    });
};

/**
 * 配置分享链接拼接推荐码
 */
//Link.getWxConfigShare = function(callback) {
//    $.ajax({
//        url: Link.prefix.realmName + "base/wx/jssdkconfig/jssdk",
//        data: {
//            url: location.href.split('#')[0]
//        },
//        success: function(data) {
//            if (data.errorCode != 0) {
//                dialog.msg(data.msg)
//                return;
//            }
//
//            wx.config({
//                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
//                appId: data.data.appId, // 必填，公众号的唯一标识
//                timestamp: data.data.timestamp, // 必填，生成签名的时间戳
//                nonceStr: data.data.nonceStr, // 必填，生成签名的随机串
//                signature: data.data.signature, // 必填，签名，见附录1
//                // jsApiList: data.data.jsApiList // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
//                jsApiList: [
//                    // 分享接口
//                    'onMenuShareTimeline',
//                    'onMenuShareAppMessage',
//                ]
//            });
//
//
//            if (callback) {
//                callback();
//            };
//
//        }
//    });
//};

Link._onWxShare = function () {

    // if (Link.g.introCode == null) {
    //     alert("邀请码为空");
    // }

    var shareLink = location.href.split('#')[0];
    var cutLink = location.href.split('shixun-mobile')[0]
    if (shareLink.indexOf('?') == -1) {
        shareLink = shareLink + '?';
    } else {
        shareLink = shareLink + '&';
    }
    //分享链接
    var link = shareLink + 'incode=' + Link.g.introCode
    //分享图标
    var imgUrl = cutLink + 'shixun-mobile/image/shixunlogo.png'
    //分享标题
    var title = document.title;
    //分享描述
    var descMeta = document.getElementsByName('description');
    var desc = descMeta.length ? descMeta[0].content : '';
    //课程详情分享加上promotionCode 可获取分享收益
    // if(shareLink.indexOf('/courseDetail') > 0){
    //     link = link + '&promotionCode=' + Link.g.introCode
    // }

    // if(Link.g.introCode == null) {
    //     $.ajax({
    //         url:Link.prefix.realmName + "portal/mycenter/getLoginUser",
    //         success:function(data){
    //             if (data.errorCode == 0) {
    //                 Link.g.introCode = data.data.introduceCode
    //             } else {
    //                 Link.g.introCode = '';
    //             }
    //         }
    //     })
    // }

    wx.ready(function () {
        //分享到朋友圈
        wx.onMenuShareTimeline({
            title: "师讯", // 分享标题
            desc: "我的课程，我做主",
            link: link, // 分享链接
            imgUrl: imgUrl, // 分享图标
            success: function () {
                // alert('分享成功')
                // 用户确认分享后执行的回调函数
            },
            cancel: function () {
                // alert('分享失败')
                // 用户取消分享后执行的回调函数
            }
        });
        // 分享给朋友
        wx.onMenuShareAppMessage({
            title: "师讯", // 分享标题
            desc: "我的课程，我做主", // 分享描述
            link: link,
            imgUrl: imgUrl, // 分享图标
            //type: '', // 分享类型,music、video或link，不填默认为link
            //dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
            success: function () {
                // alert('分享成功')
                // 用户确认分享后执行的回调函数
                if (shareLink.indexOf('/codeIn') > 0) {
                    let param = Utils.param();
                    let couponNo = param.couponNo
                    $.ajax({
                        url: Link.prefix.realmName + "portal/coupon/send-coupon",
                        data: {
                            couponNo: couponNo
                        },
                        type: 'post',
                        success: function (data) {
                            if (data.errorCode != 0) {
                                dialog.msg(data.msg);
                                return;
                            }
                        }
                    })
                }
            },
            cancel: function () {
                // alert('分享失败')
                // 用户取消分享后执行的回调函数
            }
        });
        // 分享到qq
        wx.onMenuShareQQ({
            title: title, // 分享标题
            desc: desc, // 分享描述
            link: link,
            imgUrl: imgUrl, // 分享图标
            success: function () {
                // alert('分享成功')
                // 用户确认分享后执行的回调函数
            },
            cancel: function () {
                // alert('分享失败')
                // 用户取消分享后执行的回调函数
            }
        });
        // 分享到QQ空间
        wx.onMenuShareQZone({
            title: title, // 分享标题
            desc: desc, // 分享描述
            link: link,
            imgUrl: imgUrl, // 分享图标
            success: function () {
                // alert('分享成功')
                // 用户确认分享后执行的回调函数
            },
            cancel: function () {
                // alert('分享失败')
                // 用户取消分享后执行的回调函数
            }
        });

    });

};

//获取session中的deptCode
Link.getSessionDeptCode = function () {
    var deptCode = sessionStorage.getItem("deptCode");
    if (deptCode == "" || deptCode == null || deptCode == undefined) {
        deptCode = "001";
    }
    Link.g.deptCode = deptCode;
}

//setCookie
Link.setCookie = function (key, value, expiredays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + 7 * 24 * 60 * 60 * 1000);
    document.cookie = key + "=" + escape(value) + (";expires=" + exdate.toGMTString());
}

//getCookie
Link.getCookie = (function (key) {
    if (document.cookie.length > 0) {
        var c_start = document.cookie.indexOf(key + "=");
        if (c_start != -1) {
            c_start = c_start + key.length + 1;
            var c_end = document.cookie.indexOf(";", c_start);
            if (c_end == -1) {
                c_end = document.cookie.length;
            }
            return unescape(document.cookie.substring(c_start, c_end));
        }
    }
    return "";
});

export default Link;

// ajax 全局设置
$.ajaxSettings.timeout = 30000;
// 跨域请求带上认证信息
$.ajaxSettings.xhrFields = {
    withCredentials: true
};

(function checkPromotionCode(){

    $.ajax({
        url: Link.prefix.realmName + "login/portal/verify_login",
        type: 'POST',
        global : false,
        success: function (data, textStatus, request) {

            var user = data.data;

            if (!user) {
                return;
            }

            let introduceCode = user.introduceCode;

            //wx share log
            var promotionCode = getUrlParam('promotionCode') || '';

            // save promotion code, if from
            if (promotionCode && promotionCode != user.introduceCode) {
                $.cookie('promotion_from', promotionCode, {
                    path: '/'
                });
            }
        }
    });
})();

$.ajaxSettings.beforeSend = function(XHR) {
    XHR.setRequestHeader('lastReferer', location.href);
};

// sesion超时处理
$.ajaxSettings.complete = function (jqXHR, textStatus) {

    consoleHelper.logDebug('ajax complete.');
    //if(jqXHR.getResponseHeader("sessionstatus")=="timeout"){// TODO 微信提示 - Refused to get unsafe header "sessionstatus"
    //    alert("timeout");
    //}
    if (Link.isDebug) {
        //alert('global ajaxSettings jqXHR: ' + JSON.stringify(jqXHR));
        //alert('global ajaxSettings textStatus: ' + textStatus);
        //alert('global ajaxSettings jqXHR.responseText: ' + jqXHR.responseText);
    }

    // 请求出错可能返回空数据
    //consoleHelper.logDebug('complete data', jqXHR.responseText);
    if (jqXHR.responseText == null || $.trim(jqXHR.responseText) == "") {
        return;
    }

    // try to parse data as json string
    var data = '';
    try
    {
        data = JSON.parse(jqXHR.responseText);
    }
    catch (e)
    {
        ;
    }

    if (typeof(data) !== 'object')
    {
        return;
    }

    if (data.errorCode == 2) {  // 未登录或因为会话超时，而需要重新登录

        let type = clientType.type();

        sessionStorage.setItem('gotoBeforeUrl', window.location.href);

        if (clientType.isWechat()) {
            // data.data example: "https://open.weixin.qq.com/connect/qrconnect?appid=wx2b07c913a33d290b&redirect_uri=http://api.shixun365.com/shixun/login/wx/web_login&response_type=code&scope=snsapi_login#wechat_redirect"
            // this url only for wechat oAuth login
            consoleHelper.log('wechat client, redirect to auth login.');

            if (!data.data)
            {
                consoleHelper.log('Missing wechat auth login url.');
                return;
            }

            consoleHelper.logDebug('redirect to data: ' + data.data);
            window.location.href = data.data;
            return;
        }
        else if (type === 'phone') {
            consoleHelper.logDebug('is phone, redirect to login/login.html');
            window.location.href = location.href.split('shixun-mobile')[0] + 'shixun-mobile/html/login/login.html';
        }
        else {
            consoleHelper.logDebug('is not phone, redirect to app_login.html');
            window.location.href = location.href.split('shixun-mobile')[0] + 'shixun-portal/html/app_login.html';
        }
    }
    else if (data.errorCode == 4) {
        window.location.href = '../disable/disable.html';
    }
    else if (data.errorCode == 401) {
        dialog.msg('出错了：没有权限访问。');
    }
};

// 模拟登陆
var simulateLogin = function () {
    $.ajax({
        url: Link.prefix.realmName + "login/portal/login",
        data: {
            //loginName:"13430392248",
            loginName: "18617321744",
            password: "123456"
        },
        type: 'post',
        dataType: "json",
        success: function (data) {
            if (data.errorCode != 0) {
                alert(data.msg);
            }
        }
    });
}

Link.getSessionDeptCode();




/** WEBPACK FOOTER **
 ** D:/app project/shixun-web/src/shixun-mobile/common/prefixName.js
 **/